<template>
  <Layout>
    <Content>
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>对话管理 > <b>对话列表</b></BreadcrumbItem>
      </Breadcrumb>
      <Card>
		  <span class="search_span_width">
		  <span class="search_span_width_part1">TalkKey：</span>
		  	<Input v-model="search.talk_key" clearable style="width: 150px" />
		  </span>
		  <span class="search_span_width_part1">名称：</span>
		  	<Input v-model="search.talk_name" clearable style="width: 120px" />
		  </span>
		  <span class="search_span_width_part1">手机号：</span>
		  	<Input v-model="search.mobile" clearable style="width: 120px" />
		  </span>
		  <span class="search_span_width">
		  	<span class="search_span_width_part1">类型：</span>
		  	<Select v-model="search.talk_type"  clearable style="width:100px">
		  	  <Option value="1">H5实时</Option>
		  	  <Option value="5">H5预生成</Option>
		  	  <Option value="10">APP实时</Option>
		  	  <Option value="20">APP预生成</Option>
		  	</Select>
		  </span>
		  <span class="search_span_width">
		  	<span class="search_span_width_part1">状态：</span>
		  	<Select v-model="search.enabled"  clearable style="width:100px">
		  	  <Option value="1">未启用</Option>
		  	  <Option value="2">启用</Option>
		  	</Select>
		  </span>
		  <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getAppList(1)">搜索</Button>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="talk_list"></Table>
          <Page :total="recordTotal" :current="page" :page-size="20" :show-elevator="true" @on-change="getAppList"/>
        </Card>
      </Card>
    </Content>
  </Layout>
</template>
<script>
export default {
  data(){
    return {
	  search:{
		talk_key:'',
		talk_type:'',
		enabled:'',
		talk_name : '',
		mobile:''
	  },
      talk_list:[],
      recordTotal:0,
	  page:1,
	  tableColumns:[
        { title: 'ID', key: 'id', align: 'center' },
		{ title: '名称', key: 'talk_name', align: 'center' },
		{ title: '类型', key: 'talk_type', align: 'center' ,render:(h,params) =>{
		    var name = '未知';
		    if(params.row.talk_type==1){
		      name = 'H5实时';
		    }
		    if(params.row.talk_type==5){
		      name = 'H5预生成';
		    }
			if(params.row.talk_type==10){
			  name = 'APP实时';
			}
			if(params.row.talk_type==20){
			  name = 'APP预生成';
			}
		    return h('span',{},name);
		  }
		},
		{ title: '数字人', key: 'figure_id', align: 'center' },
        { title: '角色', key: 'role_id', align: 'center' },
		{ title: '互动', key: 'interact_type', align: 'center',render:(h,params) =>{
		    var name = '未知';
		    if(params.row.interact_type==1){
		      name = 'AI知识库';
		    }
		    if(params.row.interact_type==2){
		      name = 'AI知识库+闲聊';
		    }
			if(params.row.interact_type==3){
			  name = '固定话术';
			}
		    return h('span',{},name);
		  }
		},
        { title: '操作', key: 'action', align: 'center',
          render: (h, params) => {
            let btns=[]
			if (params.row.url && params.row.enabled==2) {
				btns.push(
				    h('Button', {
				      props: { type: 'success', size: 'small' },
				      style: { marginRight: '5px', marginBottom: '5px'},
				      on: {
				        click: () => {
							window.open(params.row.url);
				        }
				      }
				    }, '访问'),
				);
			}
			if (params.row.talk_type == 5 || params.row.talk_type==20) {
				btns.push(
				    h('Button', {
				      props: { type: 'error', size: 'small' },
				      style: { marginRight: '5px', marginBottom: '5px'},
				      on: {
				        click: () => {
							this.reCreate(params.row.id);
				        }
				      }
				    }, '重新生成'),
				);
			}

            return h("div",btns);
          }
        }
      ]
    }
  },
  mounted:function(){
    this.getAppList();
  },
  computed:{

  },
  methods:{
    getAppList(page=this.page) {
      this.page = page;
      let p = {'page' : page}
      let params = Object.assign(this.search, p);
      this.http1.get('/talk/talklist',{params:params}).then(response=>{
        let data=response.data;
		//console.log(data)
        if(data.code!==0){
          alert(data.message);
        } else{
          this.talk_list = data.data.list;
          this.recordTotal = data.data.total;
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
	reCreate(talk_appid) {
	  this.http1.post('/talk/recreate',{talk_appid:talk_appid}).then(response=>{
	    let data=response.data;
		//console.log(data)
	    if(data.code!==0){
	      alert(data.message);
	    } else{
			this.$Message.info(data.message);
	    }
	  }).catch(()=>{
	    this.$Message.error('网络错误');
	  });
	}
  }

}
</script>
